import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCheckoutActions, useCheckoutState } from '@services/checkoutClient';
import PropTypes from 'prop-types';

import { SecondaryText } from '@xceedsrl/jukebox';

import {
  JAGER_GROUP_IDS,
  LIO_GROUP_IDS,
  NOVA_SBE_EVENT_IDS,
  PACHA_UNIVERSE_IDS,
} from '../constants';

import { Checkbox } from './Checkbox';
import LegalTerms from './LegalTerms';

export const BookingTerms = ({
  buttonText,
  company,
  isValidRestOfForm,
  marketingGroupConditionsRef,
  areMarketingAccepted,
  setAreMarketingAccepted,
}) => {
  const { t } = useTranslation();
  const { setMarketingGroupConditionsAccepted } = useCheckoutActions();
  const { shoppingCart, event } = useCheckoutState();
  const { marketingGroupConditionsAccepted } = shoppingCart;

  const [marketingCheckboxTranslation, setMarketingCheckboxTranslation] = useState();
  const [showMarketingGroupError, setShowMarketingGroupError] = useState(false);

  const handleMarketingAccepted = e => {
    const { checked } = e.target;
    setAreMarketingAccepted(checked);
  };

  const handleMarketingGroupAccepted = e => {
    const { checked } = e.target;
    setMarketingGroupConditionsAccepted(checked);
  };

  useEffect(() => {
    if (JAGER_GROUP_IDS.includes(event.venue.id)) {
      setMarketingGroupConditionsAccepted(false);
      setMarketingCheckboxTranslation('marketingCheckboxJagerLabel');
      return;
    }
    if (LIO_GROUP_IDS.includes(event.venue.id)) {
      setMarketingGroupConditionsAccepted(false);
      setMarketingCheckboxTranslation('marketingCheckboxLioLabel');
      return;
    }
    if (PACHA_UNIVERSE_IDS.includes(event.venue.id)) {
      setMarketingGroupConditionsAccepted(false);
      setMarketingCheckboxTranslation('marketingCheckboxPachaLabel');
    }
    if (NOVA_SBE_EVENT_IDS.includes(event.id)) {
      setMarketingGroupConditionsAccepted(false);
      setMarketingCheckboxTranslation('marketingCheckboxNovaSbeLabel');
    }
  }, [event.venue.id]);

  useEffect(() => {
    setShowMarketingGroupError(isValidRestOfForm && !marketingGroupConditionsAccepted);
  }, [isValidRestOfForm, marketingGroupConditionsAccepted]);

  return (
    <>
      <LegalTerms company={company} buttonText={buttonText} />
      <div ref={marketingGroupConditionsRef} />
      {marketingCheckboxTranslation && (
        <Checkbox
          id="marketing-group"
          name="marketing-group"
          onChange={handleMarketingGroupAccepted}
          checked={marketingGroupConditionsAccepted}
          childrenPaddingTop="0"
          boxMarginBottom={10}
          boxMarginTop={10}
          boxCheckboxMinWidth={18}
          boxCheckboxmarginTop="4px"
          alignTop
          showError={showMarketingGroupError}
          childrenMarginLeft={3}
        >
          <SecondaryText color={`${showMarketingGroupError ? 'red' : 'text.secondaryCardColor'}`}>
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: t(`common:${marketingCheckboxTranslation}`),
              }}
            />
          </SecondaryText>
        </Checkbox>
      )}
      <Checkbox
        id="marketing"
        name="marketing"
        onChange={handleMarketingAccepted}
        checked={areMarketingAccepted}
        childrenPaddingTop="0"
        boxMarginBottom={0}
        boxMarginTop={10}
        boxCheckboxMinWidth={16}
        boxCheckboxmarginTop="4px"
        alignTop
        childrenMarginLeft={3}
        boxPaddingY={marketingCheckboxTranslation ? 0 : 3}
      >
        <SecondaryText color="text.secondaryCardColor">
          <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: t('common:marketingCheckboxLabel', {
                companyCommercialName: event.company.name,
              }).replace('bold', 'strong  '),
            }}
          />
        </SecondaryText>
      </Checkbox>
    </>
  );
};

BookingTerms.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
    privacyPolicyUrl: PropTypes.string,
  }).isRequired,
  buttonText: PropTypes.string.isRequired,
  isValidRestOfForm: PropTypes.bool.isRequired,
  marketingGroupConditionsRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(HTMLDivElement) }),
  ]).isRequired,
  areMarketingAccepted: PropTypes.bool.isRequired,
  setAreMarketingAccepted: PropTypes.func.isRequired,
};
